import { set } from "../../../../components/chart/chart-color";
import warehousepurchaseFullcont from "./warehousepurchase-fullcont.html";

const dialog = require("../../../../components/dialog/dialog");
const texteditor = require("./warehousepurchase-texteditor");
const signature = require("../../../../components/signature/signature");
const settings = require("../../../../js-handler/settings");
const fullcontEntity = require("../../../../components/fullcont/fullcont-entity");
const fullcontHandler = require("../../../../components/fullcont/fullcont-handler");
const warehousepurchaseDt = require("./warehousepurchase-dt");
const warehousepurchaseMenu = require("./warehousepurchase-menu");
const { formCopy } = require("./warehousepurchase-fullcont-form");
const { form } = require("./warehousepurchase-fullcont-form");
const { purchaseMT } = require("./warehousepurchase-fullcont-multitable");
// const purchaseMT   = undefined //no MT just add this like undefined
const warehousepurchaseQuickform = require("./warehousepurchase-quickform");

/****************ELEMENTS*****************/
var htmlFc = {};
var HTMLwasSelected = false;
// variables para almanecenar y manejar datos en el localStorage
let currentInvoiceId = null; // Variable para almacenar el ID de la factura actual
let totalItems = 0; // Variable para almacenar el total de elementos

//console.log("111111====", warehousepurchaseFullcont)

function HTMLselect(detail) {
  fullcontHandler.HTMLselect(
    "purchase", //database table name****
    "warehousepurchase", //dest entity on js
    "warehousepurchase-fullcont",
    warehousepurchaseFullcont,
    form,
    formCopy,
    purchaseMT,
    editDialog,
    deleteDialog,
    dtCall,
    htmlFc
  );

  HTMLwasSelected = true;

  // htmlFc.hasFiles = true
  // fullcontHandler.rightsControl(htmlFc)
} /**/

export function start(detail) {
  //console.log('warehousepurchase-dt 5>', warehousepurchaseMT)

  if (!HTMLwasSelected) {
    HTMLselect(detail);
  }

  obj[detail.act].start(detail);
} /**/

const obj = {
  addOne: {
    start: (detail) => {
      addOne(detail, htmlFc);
    },
  },
  cancelEdit: {
    start: (detail) => {
      fullcontEntity.cancelEdit(detail, htmlFc);
    },
  },
  deleteEntity: {
    start: (detail) => {
      fullcontEntity.deleteEntity(detail, htmlFc);
    },
  },
  deleteFromDialog: {
    start: (detail) => {
      deleteFromDialog(detail, htmlFc);
    },
  },
  discard: {
    start: (detail) => {
      fullcontHandler.discard(detail, htmlFc);
    },
  },
  fullcontOptions: {
    start: (detail) => {
      warehousepurchaseMenu.start(detail, "htmlDt", htmlFc);
    },
  },
  hide: {
    start: (detail) => {
      fullcontEntity.hide(detail, htmlFc);
    },
  },
  prepareAdd: {
    start: (detail) => {
      fullcontEntity.prepareAdd(detail, htmlFc);
    },
  },
  prepareEdit: {
    start: (detail) => {
      fullcontHandler.prepareEdit(detail, htmlFc);
    },
  },
  saveFromDialog: {
    start: (detail) => {
      fullcontEntity.saveFromDialog(detail, htmlFc);
    },
  },
  selectOne: {
    start: (detail) => {
      selectOne(detail, htmlFc);
    },
  },
  update: {
    start: (detail) => {
      fullcontEntity.update(detail, htmlFc, up());
    },
  },
  editSignature: {
    start: (detail) => {
      editSignature(detail);
    },
  },
  confirmPurchase: {
    start: (detail) => {
      initializeCheckboxes(detail, htmlFc);
    },
  },
  inputToTextEditor: {
    start: (detail) => {
      inputToTextEditor(detail, htmlFc);
    },
  },
  valueToInput: {
    start: (detail) => {
      valueToInput(detail, htmlFc);
    },
  },
}; /**/

//function to send
function editSignature(detail) {
  signature.start({
    act: "edit",
    id: "warehousepurchase_form_signature",
    entity: "warehousepurchase",
    name: settings.getData().name,
  });
}

function editDialog() {
  dialog.start({ act: "show", id: "saveChanges", entity: "warehousepurchase" });
}

function deleteDialog(detail) {
  dialog.start({
    act: "show",
    dest: "warehousepurchase",
    id: "deleteElem",
    entity: "purchase",
    dbid: detail.dbid,
  });
}

function dtCall(act, result) {
  warehousepurchaseDt.start({ act: act, row: result });
}

function addOne(detail, htmlFc) {
  fullcontEntity.addOne(detail, htmlFc);
  setTimeout(() => {
    // gokuDt.start({"dest":"goku", "elem":"dt", "act":"select", "entity":"goku"})
  }, 100);
}

function selectOne(detail, htmlFc) {
  fullcontEntity.selectOne(detail, htmlFc);
  setTimeout(() => {
    loadCheckboxState(htmlFc);
    loadInputsState(htmlFc);
  }, 400);
}

function up() {
  setTimeout(() => {
    warehousepurchaseDt.start({
      dest: "warehousepurchase",
      elem: "dt",
      act: "select",
      entity: "warehousepurchase",
    });
  }, 500);
}

function deleteFromDialog(detail, htmlFc) {
  fullcontEntity.deleteFromDialog(detail, htmlFc);
  setTimeout(() => {
    warehousepurchaseDt.start({
      dest: "warehousepurchase",
      elem: "dt",
      act: "select",
      entity: "purchase",
    });
  }, 900);
}

export function initializeCheckboxes(detail, htmlFc) {
  currentInvoiceId = htmlFc.fullcontHTML.getAttribute("data-dbid");

  // Obtener todos los checkboxes dentro de la factura
  const checkboxes = htmlFc.fullcontHTML.querySelectorAll(
    "#purchase_form_purchase_vs_item .line .checkbox-line .elem"
  );

  if (!checkboxes.length) {
    console.log(`No hay checkboxes para la factura ${currentInvoiceId}`);
    return;
  }

  // Objeto para almacenar estados
  let invoiceState = {};

  checkboxes.forEach((checkbox) => {
    const lineElement = checkbox.closest(".line");
    const lineId = checkbox.closest(".line").getAttribute("lineId"); // Usamos el lineId del div padre
    invoiceState[lineId] = checkbox.checked;

    // Verificar el estado y modificar la clase en .line
    if (checkbox.checked) {
      lineElement.classList.add("check-line"); // Agrega la clase si está marcado
      lineElement.classList.remove("uncheck-line"); // Agrega la clase si está marcado
    } else {
      lineElement.classList.add("uncheck-line"); // La remueve si no está marcado
      lineElement.classList.remove("check-line"); // Agrega la clase si está marcado
    }

    // Escuchar cambios en tiempo real
    checkbox.addEventListener("change", () => {
      invoiceState[lineId] = checkbox.checked;
      saveCheckboxState(currentInvoiceId, invoiceState);
    });
  });
  saveCheckboxState(currentInvoiceId, invoiceState); // Guardar en localStorage

  // Contar los elementos seleccionados
  let totalItems = checkboxes.length;
  let selectedItems = Object.values(invoiceState).filter((item) => item);
  countCheckbox(currentInvoiceId, selectedItems.length);

  // Actualizar el contador
  updateCounter(totalItems, selectedItems.length, htmlFc);

}

function saveCheckboxState(invoiceId, state) {
  localStorage.setItem(
    `invoice_warehouse_purchase${invoiceId}`,
    JSON.stringify(state)
  );
}

function countCheckbox(invoiceId, state) {
  localStorage.setItem(
    `invoice_warehouse_purchase_count${invoiceId}`,
    JSON.stringify(state)
  );
}

function loadCheckboxState(htmlFc) {
  currentInvoiceId = htmlFc.fullcontHTML.getAttribute("data-dbid");
  const savedState = localStorage.getItem(
    `invoice_warehouse_purchase${currentInvoiceId}`
  );
  if (!savedState) return; // No hay datos guardados

  const invoiceState = JSON.parse(savedState);
  const checkboxes = htmlFc.fullcontHTML.querySelectorAll(
    "#purchase_form_purchase_vs_item .line .checkbox-line .elem"
  );
  console.log(checkboxes.length);
  checkboxes.forEach((checkbox) => {
    const lineElement = checkbox.closest(".line");
    const lineId = checkbox.closest(".line").getAttribute("lineId");
    if (invoiceState[lineId] != undefined) {
      checkbox.checked = invoiceState[lineId];

      // Verificar el estado y modificar la clase en .line
      if (checkbox.checked) {
        lineElement.classList.add("check-line"); // Agrega la clase si está marcado
        lineElement.classList.remove("uncheck-line"); // Agrega la clase si está marcado
      } else {
        lineElement.classList.add("uncheck-line"); // La remueve si no está marcado
        lineElement.classList.remove("check-line"); // Agrega la clase si está marcado
      }
    }
  });

  // Contar los elementos seleccionados
  totalItems = checkboxes.length;
  let selectedItems = Object.values(invoiceState).filter((item) => item);
  countCheckbox(currentInvoiceId, selectedItems.length);

  // Actualizar el contador
  updateCounter(totalItems, selectedItems.length, htmlFc);
}

function updateCounter(totalItems, items, htmlFc) {
  const counterContainer = htmlFc.fullcontHTML.querySelector(
    ".mt-8 .count-container .count-label"
  );

  if (counterContainer) {
    counterContainer.innerHTML = totalItems + " / " + items;
  }
}

function inputToTextEditor(detail, htmlFc) {
  texteditor.start({
    act: "show",
    dest: "warehousepurchase",
    id: "textEditorTest",
    lineId: detail.lineId,
  });
  
  let textEditor = document.querySelector("#textEditor");
  
  textEditor.focus();
}

function valueToInput(detail, htmlFc) {
  currentInvoiceId = htmlFc.fullcontHTML.getAttribute("data-dbid");
  let lineId = detail.lineId;
  let textEditorValue = document.querySelector("#textEditor").value;
  saveinputState(currentInvoiceId, lineId, textEditorValue);
  loadInputsState(htmlFc);
}

function saveinputState(invoiceId, lineId, state) {
  localStorage.setItem(
    `invoice_warehouse_purchase_note${invoiceId}_${lineId}`,
    JSON.stringify(state)
  );

}

function loadInputsState(htmlFc) {
  currentInvoiceId = htmlFc.fullcontHTML.getAttribute("data-dbid");
  let inputsNotes = htmlFc.fullcontHTML.querySelectorAll(
    "#purchase_form_purchase_vs_item .line .multitable-grid-purchase .multitable-flex-purchase .notes .note"
  );
  let lineId;
  inputsNotes.forEach((input) => {
    lineId = input.getAttribute("itemId");
    const savedState = localStorage.getItem(
      `invoice_warehouse_purchase_note${currentInvoiceId}_${lineId}`
    );

    if (savedState) {
      const elem = input.querySelector(".elem");
      if (elem) {
        elem.value = JSON.parse(savedState);
      }
    }
  });
}
